// Centralized list of all possible permissions in the application
export const ALL_PERMISSIONS = [
	"access_completed_extractions",
	"access_data_viewer",
	"access_work_queues",
	"create_user",
	"edit_user",
	"edit_user_self",
	"source_data_extraction",
	"delete_user",
	"delete_file",
	"download_data",
	"level_1",
	"level_2",
	"level_3",
	"manage_api_tokens",
	"manage_concepts",
	"manage_interviews",
	"manage_organizations",
	"manage_projects",
	"manage_tags",
	"manage_units",
	"quality_control",
	"reassign_extractions",
	"search_literature",
	"upload_file",
	"sde_training",
	"view_activity_metrics",
];
